import { AfterViewInit, Component, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-browser-message",
    templateUrl: "./browser-message.component.html",
    styleUrls: ["./browser-message.component.scss"]
})
export class BrowserMessageComponent implements OnInit {
    public translation: "";

    ngOnInit(): void {
        this.translateService
            .get("browser-message.message")
            .subscribe((translation) => {
                this.translation = translation.replace(
                    "{{browser}}",
                    '<a href="https://www.google.com/chrome/">Google Chrome</a>'
                );
            });
    }

    constructor(
        private platform: Platform,
        private translateService: TranslateService
    ) {}

    get isDesktop(): boolean {
        return this.platform.is("desktop");
    }

    get isUnsupportedBrowser(): boolean {
        const isChrome = navigator.userAgent.indexOf("Chrome") !== -1;

        return !isChrome;
    }
}
